import { useDatabaseContent } from '@databases/database-state';
import { appStoreUtils } from '@databases/redux/store';
import { selectDatabaseByContentIdStatus } from '@databases/utils/redux/databases/selectors';
import { AsyncOperationStatus } from '@databases/utils/redux/redux';
import { useEffect } from 'react';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';
import { CommentAnalyticsType } from '@canvas/comments/comment-types';
import { getNotificationStore } from '@canvas/comments/state/notification-store';

export const useUnreadComments = () => {
  const { contentId } = useDatabaseContent();
  const databaseStatus = appStoreUtils.useSelector((state) =>
    selectDatabaseByContentIdStatus(state, { contentId })
  );
  useEffect(() => {
    if (
      databaseStatus?.status === AsyncOperationStatus.SUCCEEDED &&
      isFeatureFlagEnabled('unreadComments')
    ) {
      const notificationStore = getNotificationStore();
      // No need to await this, as not core to setting up database
      notificationStore.setViewedComments(CommentAnalyticsType.DATABASE);
    }
  }, [databaseStatus]);
};
